import { gql } from "@apollo/client";

const locationGQL = gql`
  query Location($loc_id: String!) {
    locations(locID: $loc_id) {
      inst_name
      name
      modules {
        id
        inst_id
        loc_id
        moduleid
        vhost
        web
        facebook
        thirdparty
        vr
        mobile
        mobile_vhost
        mobile_web
      }
      actionButtons {
        register {
          url
          name
          bgColor: bg_color
          fontColor: font_color
        }
        actions {
          actionid
          analyticsAction
          name
          url
          typeid
          bgColor: bg_color
          fontColor: font_color
        }
        defaultActions {
          actionid
          analyticsAction
          name
          url
          typeid
          bgColor: bg_color
          fontColor: font_color
        }
      }

      # Stops for this location
      stops {
        stopid
        title
        descriptions {
          description
          language
        }
        main_media_id
        main_media_type
        photos {
          id
          title
          description
          smallurl
          network
          url
        }
        videos {
          id
          title
          description
          smallurl
          type
          url
          videoid
          network
        }
        panoramas {
          title
          description
          start_fov
          start_lat
          start_lon
          exit_lat
          exit_lon
          id
          smallurl
        }
      }

      # Tour configuration
      tours {
        status
        tourid
        # these are not the same as custom trails
        trails {
          points {
            stopid
            dir
            orientation
            latitude
            longitude
          }
        }
      }

      # interactive map information
      interactivemaps {
        customTrails {
          id
          name
          order
          Stops {
            stopid
            title
            sort_order
            customLat: custom_lat
            customLng: custom_lng
            realLat: real_lat
            realLng: real_lng
            tourLat: tour_lat
            tourLng: tour_lng
          }
        }

        #lat and lng for that location
        centerLat: center_lat
        centerLng: center_lng

        #Custome tile support

        minLat: min_lat
        minLng: min_lng
        maxLat: max_lat
        maxLng: max_lng
        centerLat: center_lat
        centerLng: center_lng
        zoom

        tiles {
          loc_id
          zoom
          minx
          miny
          maxx
          maxy
          path
          version
        }

        mapMarkers {
          customLat: custom_lat
          customLng: custom_lng
          realLat: real_lat
          realLng: real_lng
        }

        # the stop info needed for render the maps
        stops {
          id
          loc_id
          college
          title
          fullMapDescription
          audio
          totalPanos
          hasPanorama
          panoThumb
          totalPhotos
          hasPicture
          photoThumb
          totalVideos
          hasVideo
          videoThumb
          isPointOfInterest
          radius
          startLat: startlat
          startLng: startlng
          customLat: customlat
          customLng: customlng
          centerLat: centerlat
          centerLng: centerlng
          realLat: reallat
          realLng: reallng

          # shape of the stop
          custom_shape: shape(maptype: "custom") {
            lat
            lng
            type
          }
          real_shape: shape(maptype: "native") {
            lat
            lng
            type
          }
        }
      }
    }
  }
`;

export default locationGQL;
